import React, { Component } from 'react';

import { Dialog, DialogTitle, List, ListItem, ListItemText } from '@material-ui/core';
import ArrowDown from '@material-ui/icons/ExpandMoreRounded';
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import ArrowRight from '@material-ui/icons/NavigateNextRounded';

import { Button } from '../Button/Button';

export interface IOption {
  label: string;
  value: string;
}

interface IProps {
  defaultOption?: IOption;
  noAngleTitle?: boolean;
  onSelect: any;
  options: IOption[];
  sidemenuContext?: boolean;
  title: string;
  onClose?: any;
}

interface IState {
  isOpen: boolean;
  selected: IOption;
}

class Select extends Component<IProps, IState> {
  public onClose = this.props.onClose ? this.props.onClose : () => this.setState({ isOpen: false });

  constructor(props: IProps) {
    super(props);
    this.state = {
      isOpen: false,
      selected: props.defaultOption || props.options[0]
    };

    this.toggle = this.toggle.bind(this);
  }

  public componentDidUpdate(): void {
    const { defaultOption } = this.props;
    const { selected } = this.state;

    if (defaultOption && defaultOption.value !== selected.value) {
      this.setState({ selected: defaultOption });
    }
  }

  public toggle(): void {
    this.setState({ isOpen: !this.state.isOpen });
  }

  public select = (selected: IOption) => () => {
    this.setState({ selected, isOpen: false });
    this.props.onSelect(selected);
  };

  public render(): JSX.Element {
    const { title, noAngleTitle, options, sidemenuContext } = this.props;
    const { selected, isOpen } = this.state;

    return (
      <>
        {!!sidemenuContext ? (
          <div className="sidemenu-picker">
            <div className="label">{title}</div>
            <Button
              classes={{
                label: 'label',
                root: 'sidemenu-current-pick'
              }}
              onClick={this.toggle}
            >
              <span>{selected && selected.label}</span>
              <KeyboardArrowRightRoundedIcon classes={{ root: 'icon' }} />
            </Button>
          </div>
        ) : !!noAngleTitle ? (
          <Button
            className={'select-button override -no-angle'}
            classes={{ label: '-no-angle' }}
            id="select-button"
            onClick={this.toggle}
            style={{ background: 'white' }}
          >
            <div className="title -no-angle">{title}</div>
            <span className="label -no-angle">{selected.label}</span>
            <ArrowRight className="select-arrow override -no-angle" color="primary" />
          </Button>
        ) : (
          <Button
            className={'select-button override'}
            id="select-button"
            onClick={this.toggle}
            style={{ background: 'white' }}
          >
            <div className="title">
              {title}
              <div className="angle" />
              <div className="angle2" />
            </div>
            <span className="label">{selected.label}</span>
            <ArrowDown className="select-arrow override" color="primary" />
          </Button>
        )}
        <Dialog open={isOpen} className="select-dialog" onClose={this.onClose}>
          <DialogTitle className="select-header">{title}</DialogTitle>
          <List>
            {options.map(option => (
              <ListItem
                className="select-item"
                button={true}
                onClick={this.select(option)}
                id={`option-${option.value}`}
                key={`option-${option.value}`}
              >
                <ListItemText primary={option.label} />
              </ListItem>
            ))}
          </List>
        </Dialog>
      </>
    );
  }
}

export { Select };
